import { useEffect, useState, ReactNode } from 'react'
import { Box, Popover, PopoverOrigin } from '@mui/material'

interface CustomPopoverProps {
  buttonLabel: ReactNode
  anchorOrigin?: PopoverOrigin
  transformOrigin?: PopoverOrigin
  closed?: boolean
  setClosed?: (closed: boolean) => void
  children: ReactNode
}

const CustomPopover = ({
  buttonLabel,
  anchorOrigin = {
    vertical: 'center',
    horizontal: 'left'
  },
  transformOrigin = {
    vertical: 'center',
    horizontal: 'right'
  },
  closed = false,
  setClosed,
  children
}: CustomPopoverProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (closed) {
      setAnchorEl(null)
      if (setClosed) {
        setClosed(false)
      }
    }
  }, [closed, setClosed])

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    event.stopPropagation()
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event?: React.MouseEvent<HTMLElement>): void => {
    event?.stopPropagation()
    event?.preventDefault()
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Box>
      <Box onClick={handleClick}>{buttonLabel}</Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {children}
      </Popover>
    </Box>
  )
}

export default CustomPopover
